export const FLAG_GETTING_CABIN_CREW_COMMISSIONS =
  'FLAG_GETTING_CABIN_CREW_COMMISSIONS';
export const GET_CABIN_CREW_COMMISSIONS = 'GET_CABIN_CREW_COMMISSIONS';
export const CLEAR_CABIN_CREW_COMMISSIONS = 'CLEAR_CABIN_CREW_COMMISSIONS';
